import { useState, useEffect } from 'react'

export const useIsMobileView = (): boolean => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    function handleResize (): void {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width < 1000
}

export const useIsLargeView = (): boolean => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    function handleResize (): void {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return width > 1600
}
